import { Box } from "@chakra-ui/layout";
import { Tooltip } from "@chakra-ui/react";
import { HandleIcon } from "lib/icons";
import { FC, forwardRef, Ref } from "react";
import {usePack} from "lib/hooks";
import { usePackContext } from "domains/pack";
import { isCollaborator, isPreviewingPack, isReadOnly } from "lib/utils";
import { useRouter } from "next/router";

type Props = {
  isGroupActive: boolean;
  ref: Ref<HTMLDivElement>;
  onSelectGroup: Function;
}

export const GroupDragHandle: FC<Props> = forwardRef(({ isGroupActive, onSelectGroup }, ref) => {
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const { pathname } = useRouter();
  
  if (isReadOnly(pack) || isCollaborator(pack) || isPreviewingPack(pathname)) {
    return null;
  }

  return (
    <Box
      position="absolute"
      display="inline-block"
      top="0"
      bottom="0"
      left="-44px"
      paddingRight="40px"
      transition="0.15s ease all"
      height="100%"
      opacity={isGroupActive ? 1 : 0}
      _hover={{
        cursor: 'pointer',
        opacity: 1,
      }}
    >
      <Tooltip lineHeight="1.4" placement="left" hasArrow fontSize="xs" textAlign="center" label={
        <>
          <strong>Drag</strong> to move<br />
          <strong>Click</strong> to select
        </>
      }>
        <Box ref={ref} onClick={(e) => onSelectGroup(e)} height="22px" position="absolute" top="50%" mt="-15px">
          <HandleIcon
            boxSize="22px"
            color="brand.500"
            layerStyle={[ 'with-transition' ]}
            _hover={{ opacity: 1 }}
          />
        </Box>
      </Tooltip>
    </Box>
  )
})

GroupDragHandle.displayName = "GroupDragHandle";

